import {Component, OnInit} from '@angular/core';
import {UntypedFormControl, UntypedFormGroup} from '@angular/forms';
import {takeUntil} from 'rxjs/operators';
import {translations} from '../../../../environments/translations.ru';
import {BaseFieldType} from 'compob2b-libs';

@Component({
    selector: 'app-size-property',
    templateUrl: './size-property.component.html',
    standalone: false
})
export class SizePropertyComponent extends BaseFieldType implements OnInit {
  formSize = new UntypedFormGroup({
    depth: new UntypedFormControl(null),
    width: new UntypedFormControl(null),
    height: new UntypedFormControl(null),
  });

  depthPlaceholder = translations.depth + ': ';
  widthPlaceholder = translations.width + ': ';
  heightPlaceholder = translations.height + ': ';

  ngOnInit(): void {
    this.depthPlaceholder += this.props.isInteger ? translations.intNumberPlaceholder.toLowerCase()
      : translations.floatNumberPlaceholder.toLowerCase();
    this.widthPlaceholder += this.props.isInteger ? translations.intNumberPlaceholder.toLowerCase()
      : translations.floatNumberPlaceholder.toLowerCase();
    this.heightPlaceholder += this.props.isInteger ? translations.intNumberPlaceholder.toLowerCase()
      : translations.floatNumberPlaceholder.toLowerCase();

    if (this.field.defaultValue !== null && this.field.defaultValue !== undefined) {
      const size = JSON.parse(this.field.defaultValue);
      if (size) {
        this.formSize.patchValue(size);
      }
    }

    this.formSize.valueChanges
      .pipe(takeUntil(this.unsubscribe))
      .subscribe(data => {
        this.formControl.setValue(JSON.stringify(data));
        this.formControl.markAsTouched();
      });
  }

}
